var promise = require('promise/domains');
var deferred = require('deferred');
deferred.all = promise.all;
var bluebird = require('bluebird');
deferred.mapSeries = bluebird.mapSeries.bind(bluebird);
module.exports = deferred;
